import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {BasicBitmapCountUp} from "../../components/BasicBitmapCountUp";
import {BenjiKIVGameAssets} from "../../BenjiKIVGameAssets";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {gsap} from "gsap";
import {BenjiKIV} from "../../BenjiKIV";

export class BenjiKIVWinWaysView extends PIXI.Container implements StageLayer {

    private _toggleAmount: BasicBitmapCountUp;
    private _toggleWays: PIXI.Text;

    constructor() {
        super();
        this.name = "BenjiKIVWinWaysView";

        this.init();
    }

    public setYPosWays(yPos: number): void {
        this._toggleWays.y = yPos;
    }

    public showInitialWinWays(): void {
        const ways: number = BenjiKIV.model.totalWaysWon,
            text: string = (ways === 1 ? "Way Won" : "Ways Won");

        this._toggleWays.text = ways + " " + BenjiKIV.apiPlugin.translations.translate(text);
        this._toggleWays.visible = true;
    }

    public hideInitialWinWays(duration: number): void {
        if (!this._toggleWays.visible) {
            return;
        }

        const tl: gsap.core.Timeline = gsap.timeline();

        tl.to(this._toggleWays, {
            duration: duration,
            alpha: 0
        });
        tl.add(() => {
            this._toggleWays.visible = false;
            this._toggleWays.alpha = 1;
        });
    }

    public showToggleWinWays(amount: number, ways: number): void {
        const text: string = (ways === 1 ? "Way Won" : "Ways Won");
        this._toggleAmount.getCountAnimation(amount, amount, 0.01);
        this._toggleAmount.visible = true;

        this.setYPosWays(70);

        // shouldn't show ways won on win cap as they are only for that spin, but cap win is for whole round.
        if (!BenjiKIV.model.brokeBank) {
            this._toggleWays.text = ways + " " + BenjiKIV.apiPlugin.translations.translate(text);
            this._toggleWays.visible = true;
        }
    }

    public hideToggleWinWays(): void {
        if (!this._toggleAmount.visible) {
            return;
        }

        const tl: gsap.core.Timeline = gsap.timeline();

        tl.to([this._toggleAmount, this._toggleWays], {
            duration: 0.3,
            alpha: 0
        });
        tl.add(() => {
            this._toggleAmount.visible = false;
            this._toggleAmount.alpha = 1;

            this._toggleWays.visible = false;
            this._toggleWays.alpha = 1;
        });
    }

    private init(): void {
        this.position.set(360, 400);

        this._toggleAmount = new BasicBitmapCountUp({
            fontName: BenjiKIVGameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize: 40,
            tint: 0xffffff
        }, 650, new PIXI.Point(0.5, 0.5));
        this._toggleAmount.visible = false;

        this._toggleWays = new PIXI.Text("", new PIXI.TextStyle({
            dropShadow: true,
            dropShadowAngle: 8,
            dropShadowBlur: 3,
            dropShadowDistance: 3,
            fill: "#FFFF00",
            fontFamily: OpenSans.FAMILY,
            fontSize: 50,
            fontWeight: FontWeight.BOLD,
            lineJoin: "round",
            miterLimit: 6,
            strokeThickness: 4
        }));
        this._toggleWays.visible = false;
        this._toggleWays.anchor.set(0.5);
        this.setYPosWays(70);

        this.addChild(this._toggleWays, this._toggleAmount);
    }
}